// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ov-0";